import { STATUSES } from "@/lib/constants";
import { Badge } from "ui/components/badge";

export const StatusCell = ({ getValue }) => {
  const status = getValue();

  if (!status) {
    return;
  }

  return (
    <Badge className={STATUSES[status]?.className}>
      {STATUSES[status]?.label ?? status}
    </Badge>
  );
};
